import { render, staticRenderFns } from "./ShuJuJi.vue?vue&type=template&id=c25760b8&scoped=true&"
import script from "./ShuJuJi.vue?vue&type=script&lang=js&"
export * from "./ShuJuJi.vue?vue&type=script&lang=js&"
import style0 from "./ShuJuJi.vue?vue&type=style&index=0&id=c25760b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25760b8",
  null
  
)

export default component.exports